// routes/change-email.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/change-email')

export const handle = { name: 'change-email' }

export default dynamic(getClientModule, { ssr: false })
